module.exports = __webpack_public_path__ + "static/media/section.b842c6b1.svg";